import { Vue, Component, Prop } from "vue-property-decorator";
// import { productStore } from "@/store/ProductModule";
// import { RelatedProductList } from "./";
import { Variant, RelatedProductModel, TranslationModel, ProductModel, CarbonSavingsModel } from "../models/product";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { SwiperOptions } from "swiper";
import { CarbonSavingsCalculation } from "./";

@Component({
    components: {
        Swiper,
        SwiperSlide,
        CarbonSavingsCalculation: () => import("./ProductPage/CarbonSavingsCalculation"),
    }
})
export default class AddToCartModal extends Vue {
    public $refs!: {
        swiper: any;
        popup: any;
        checkoutbutton: any;
    };

    @Prop()
    protected vm!: any;
    @Prop()
    protected carbonSavingsModel!: CarbonSavingsModel;
    @Prop()
    protected quantity!: number;

    protected swiperOptions: SwiperOptions = {
        init: true,
        slidesPerView: 2,
        spaceBetween: 15,
        direction: "horizontal",
        effect: "slide",
        initialSlide: 0,
        observer: true,
        centerInsufficientSlides: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        loop: false,
        watchOverflow: true,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 480px
            480: {
                slidesPerView: 3,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 4,
            }
        },
    };
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected mounted() {
        this.$refs.checkoutbutton.focus();
    }

    protected close() {
        this.$emit("close", true);
    }

    protected prev() {
        this.$refs.swiper.$swiper.slidePrev();
    }

    protected next() {
        this.$refs.swiper.$swiper.slideNext();
    }
}
